// The oven's two rack timers. COUNT-DOWN model (tester feedback): placing a
// pan on a rack auto-sets its timer to the recipe's cook time and starts it
// counting down. ✓ pauses/resumes, ✗ resets back to the full cook time.
// Purely advisory — pans cook because they're in the oven (BakingSystem);
// the timer is the player's cue for when to pull them out.
// Ticked globally from HeaderBar in game-seconds; survives scene switches.
export interface OvenTimer {
  running: boolean;
  remainingSec: number;
  seedSec: number; // what ✗ resets to; 0 = rack has no timer set
}

class OvenTimers {
  readonly timers: [OvenTimer, OvenTimer] = [
    { running: false, remainingSec: 0, seedSec: 0 },
    { running: false, remainingSec: 0, seedSec: 0 },
  ];

  tick(dtSec: number): void {
    for (const t of this.timers) {
      if (t.running && t.remainingSec > 0) {
        t.remainingSec = Math.max(0, t.remainingSec - dtSec);
      }
    }
  }

  // Auto-set at pan placement: full cook time, running.
  setFor(index: 0 | 1, cookTimeSec: number): void {
    const t = this.timers[index];
    t.seedSec = cookTimeSec;
    t.remainingSec = cookTimeSec;
    t.running = true;
  }

  clear(index: 0 | 1): void {
    const t = this.timers[index];
    t.running = false;
    t.remainingSec = 0;
    t.seedSec = 0;
  }

  toggle(index: 0 | 1): void {
    const t = this.timers[index];
    if (t.remainingSec > 0) t.running = !t.running;
  }

  reset(index: 0 | 1): void {
    const t = this.timers[index];
    t.remainingSec = t.seedSec;
    t.running = false;
  }
}

export const ovenTimers = new OvenTimers();
